import React from 'react';

import { AdminFormTab } from 'Components/Admin/Form';

const templatesInvoice = [
  {
    id: 1,
    title: 'Standard Invoice',
    description: `The most common invoice form that small businesses create and the format is flexible enough to fit most
    industries and billing cycles.`,
  },
  {
    id: 2,
    title: 'Credit Invoice',
    description: `This is issued by a business that needs to provide a client with a discount or a refund, or to correct a previous invoicing error.`,
  },
  {
    id: 3,
    title: 'Debit Invoice',
    description: `For business that needs to increase the client amount. Сan be useful when it needs to make a slight adjustment to an existing bill.`,
  },
];

const templatesOrder = [
  {
    id: 1,
    title: 'Market Order',
    description: `Used if the trader wants in/out of a trade quickly and is not concerned about the price they get.`,
  },
  {
    id: 2,
    title: 'Limit buy Order',
    description: `It ensure that a buyer pays only a specific price to purchase. It can remain in effect until they are executed, expire, or are canceled.`,
  },
  {
    id: 3,
    title: 'Stop Order',
    description: `It can be a order meaning it takes any price once triggered, or it can be a order where it can only execute within a price range after being triggered.`,
  },
];


const InvoiceAndOrder = () => {
  const handleSubmit = (value) => console.log(value);

  const formItems = [
    {
      title: 'Invoice settings',
      subTitle: 'Choose a ready-made invoice template or create your own.',
      className: 'invoice-order-form_big-label',
      items: [
        {
          type: 'tabs',
          name: 'invoiceSubjectTemplateType',
          label: 'Templates',
          options: templatesInvoice,
          subForm: {
            items: [
              {
                type: 'text',
                name: 'body',
                label: 'Body',
                placeholder: 'Type template body',
              },
            ],
            onSubmit: handleSubmit,
          },
        },
        {
          type: 'pdf',
          name: 'invoiceSubjectTemplate',
          label: 'PDF document',
          subLabel: 'Customise default invoice subject description for auto-generated invoice',
          placeholder: 'Start to create your PDF document template...',
        },
      ],
    }, {
      title: 'Order settings',
      subTitle: 'Choose a ready-made order template.',
      className: 'invoice-order-form_big-label',
      items: [
        {
          type: 'tabs',
          name: 'orderSubjectTemplateType',
          label: 'Templates',
          options: templatesOrder,
          subForm: {
            items: [
              {
                type: 'text',
                name: 'body',
                label: 'Body',
                placeholder: 'Type template body',
              },
            ],
            onSubmit: handleSubmit,
          },
        },
        {
          type: 'pdf',
          name: 'orderSubjectTemplate',
          label: 'PDF document',
          subLabel: 'Customise default order subject description for auto-generated order',
          placeholder: 'Start to create your PDF document template...',
        },
      ],
    },
    {
      title: 'Document settings',
      subTitle: 'Setting up data for generating official documents.',
      items: [
        {
          type: 'text',
          name: 'officialName',
          label: 'Official title',
          subLabel: 'The name of the project that will be displayed in invoices and orders. Use an official title, the customer will see it.',
          placeholder: 'Enter official title',
        },
        {
          type: 'date',
          name: 'officialContractStartDate',
          label: 'Official contract start date',
          subLabel: 'The official start date for the development of the project. This will show up on invoices and official documents.',
          placeholder: 'Choose start date',
        },
      ],
    },
  ];

  return (
    <div className="invoice-order-form" data-testid="projects-invoice-and-order-form">
      <AdminFormTab
        formItems={formItems}
        isBlocks
      />
    </div>
  );
};

export default InvoiceAndOrder;
